import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { db } from "@/lib/firebase";
import { doc, getDoc } from "firebase/firestore";

const Analytics: React.FC = () => {
	const [analytics, setAnalytics] = useState<any | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchAnalytics = async () => {
			setLoading(true);
			setError(null);
			try {
				const docRef = doc(db, "analytics", "summary");
				const docSnap = await getDoc(docRef);
				setAnalytics(docSnap.exists() ? docSnap.data() : null);
			} catch (err: any) {
				setError("Failed to load analytics.");
			} finally {
				setLoading(false);
			}
		};
		fetchAnalytics();
	}, []);

	return (
		<div>
			<h2 className="text-2xl font-bold mb-4">Analytics</h2>
			{loading ? (
				<div className="py-8 text-center text-muted-foreground">Loading...</div>
			) : error ? (
				<div className="py-8 text-center text-destructive">{error}</div>
			) : !analytics ? (
				<div className="py-8 text-center text-muted-foreground">No analytics data yet.</div>
			) : (
				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
					{Object.entries(analytics).map(([label, value]) => (
						<Card key={label}>
							<CardHeader>
								<CardTitle>
									{label
										.replace(/([A-Z])/g, " $1")
										.replace(/^./, (str) => str.toUpperCase())}
								</CardTitle>
							</CardHeader>
							<CardContent>
								<div className="text-3xl font-bold">{String(value)}</div>
							</CardContent>
						</Card>
					))}
				</div>
			)}
		</div>
	);
};

export default Analytics;
